package one.healthium.domain.paywall.models


import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.JsonClassDiscriminator
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlinx.serialization.modules.subclass

@OptIn(ExperimentalSerializationApi::class)
@JsonClassDiscriminator("id")
sealed interface PaywallScreenView {
    val id: String

    companion object {
        val module = SerializersModule {
            polymorphic(PaywallScreenView::class) {
                subclass(PaywallImageView::class)
                subclass(PaywallEmptyView::class)
                subclass(PaywallReviewsView::class)
                subclass(PaywallMainPlansView::class)
                subclass(PaywallOtherPlansView::class)
                subclass(PaywallPurchaseButtonView::class)
                subclass(PaywallSecuredView::class)
                subclass(PaywallPrivacyView::class)
            }
        }
    }
}